import React from 'react'
import TemplatesContainer from '../Layout/Layout'
import Management from '../../pages/Management'
import Appointments from '../../pages/Appointments'
import STPLPage from '../../pages/STPLPage'
import PatientPage from '../../pages/PatientPage'
import PaymentsReview from '../../pages/PaymentsReview'
import DrDashboardPage from '../../pages/DrDashboardPage'

const ProtectedManagement = () => {
  return <Management />
}

const ProtectedPaymentsReview = () => {
  return <PaymentsReview />
}

export const pages = [
  {
    children: [
      {
        path: 'dashboard',
        title: 'Overview',
        exact: true,
        layout: TemplatesContainer,
        element: DrDashboardPage
      },
      {
        path: 'stomatology/*',
        title: 'Stomatology',
        layout: TemplatesContainer,
        element: () => <STPLPage category={'stomatology'} />
      },
      {
        path: 'pulmonology/*',
        title: 'Pulmonology',
        layout: TemplatesContainer,
        element: () => <STPLPage category={'pulmonology'} />
      },
      {
        path: 'stomatology/patient/:patientId',
        exact: true,
        title: 'Patient File',
        layout: TemplatesContainer,
        element: PatientPage
      },
      {
        path: 'pulmonology/patient/:patientId',
        exact: true,
        title: 'Patient File',
        layout: TemplatesContainer,
        element: PatientPage
      },
      {
        path: 'appointments',
        title: 'Appointments',
        exact: true,
        layout: TemplatesContainer,
        element: Appointments
      },
      {
        path: 'payments',
        title: 'Payments Review',
        exact: true,
        layout: TemplatesContainer,
        element: ProtectedPaymentsReview
      },
      {
        path: 'admin/*',
        title: 'Managements',
        layout: TemplatesContainer,
        element: ProtectedManagement
      }
    ]
  }
]
